module.exports = __webpack_public_path__ + "static/media/S3N8-1.9a7a5d11.svg";